/**
 * Roles allowed to edit Is Compliant / Compliance Date Met / Compliance
 * Percentage once a patient's compliance has been answered.
 *
 * S3DEV2-7822: the FE never sees the raw role for SaaS users —
 * transformUserRole (utils/misc.js) renames admin-elevated
 * CompanyAdministrator -> ServiceAdmin at login, which locked SaaS company
 * admins out of these fields. ServiceAdmin restores them.
 *
 * ServiceCoach (admin-elevated OfficeAdministrator) is deliberately NOT
 * listed: product scoped the fix (S3DEV2-7822) to the SaaS company-admin
 * type only. The backend gate
 * (PatientsSerializer.EditComplianceInfo) still accepts raw
 * OfficeAdministrator, so the FE is intentionally stricter than the BE here.
 */
export const COMPLIANCE_MET_EDIT_ROLES = [
  "Administrator",
  "CompanyAdministrator",
  "OfficeAdministrator",
  "ServiceAdmin"
];

// Unknown, missing, or not-yet-loaded roles fall through to false (read-only).
export const canEditComplianceMet = role =>
  COMPLIANCE_MET_EDIT_ROLES.includes(role);
